var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilterIconWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#707070",
    d: "M807 176h24v24h-24z",
    "data-name": "Rectangle 11325"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    "data-name": "Mask Group 146",
    transform: "translate(-807 -176)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "invisible box"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M807 176h24v24h-24z",
    "data-name": "Rectangle 11327"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M820.5 198h-.35l-3.5-.75a1.55 1.55 0 0 1-1.15-1.5v-6.25l-6-5.6a1.3 1.3 0 0 1-.5-1.1v-3.3a1.5 1.5 0 0 1 1.5-1.5h17a1.5 1.5 0 0 1 1.5 1.5v3.8a1.4 1.4 0 0 1-.55 1.15l-6.45 5.1v6.95a1.521 1.521 0 0 1-1.5 1.5Zm-3-2.7 2.5.6v-7.3l7-5.55V180h-16v2.6l6.5 6.05Z",
    "data-name": "Path 14919"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIconWhite);
export default __webpack_public_path__ + "static/media/filterIconWhite.9f78dff69f2a0162c3de8b25229dc055.svg";
export { ForwardRef as ReactComponent };